import { Folder } from "lucide-react";
import { cn } from "../lib/utils";
import { COLLECTION_ICONS } from "../lib/collectionIcons";

interface CollectionIconProps {
  icon?: string | null;
  className?: string;
}

export function CollectionIcon({ icon, className }: CollectionIconProps) {
  const Icon = (icon && COLLECTION_ICONS[icon]?.icon) || Folder;
  return <Icon className={cn("h-5 w-5", className)} aria-hidden="true" />;
}
